import { render, staticRenderFns } from "./mobile-register-form.vue?vue&type=template&id=6ad610fb&scoped=true&"
import script from "./mobile-register-form.vue?vue&type=script&lang=js&"
export * from "./mobile-register-form.vue?vue&type=script&lang=js&"
import style0 from "./mobile-register-form.vue?vue&type=style&index=0&id=6ad610fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad610fb",
  null
  
)

export default component.exports